import { FullPageBanner } from '../../components/FullPageBanner/FullPageBanner';

export const InvalidURL = () => {
  return <FullPageBanner message="This URL is not valid!" />;
};
